import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/** What the stars need of a product: the rating and its count, in whichever form the caller holds them. */
export type RatingSource = {
  readonly rating: string | number | null;
  readonly ratecount?: string | number | null;
};

@Component({
  selector: 'app-product-rating',
  imports: [MatIconModule],
  templateUrl: './product-rating.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./product-rating.component.scss'],
})
export class ProductRatingComponent {
  readonly product = input.required<RatingSource>();
  readonly size = input('larger');
  /** One star and the number instead of the five-star row, for a narrow slot. */
  readonly compact = input(false, { transform: booleanAttribute });

  readonly rating = computed(() => {
    const product = this.product();
    return product && product.rating ? parseFloat(product.rating.toString()) : 0;
  });

  readonly ratingLabel = computed(() =>
    String(this.product().rating ?? '')
      .split('.')
      .join(',')
  );

  readonly countLabel = computed(() => {
    const count = this.product().ratecount;
    return count === null || count === undefined ? '' : `(${count})`;
  });

  readonly filledStars = computed(() => new Array(Math.floor(this.rating())));

  readonly emptyStars = computed(() => new Array(5));

  readonly partialStarWidth = computed(() => this.rating() % 1);

  readonly partialStarClipPath = computed(() => {
    const width = this.partialStarWidth();
    return `polygon(0 0, ${width * 100}% 0, ${width * 100}% 100%, 0% 100%)`;
  });
}
